module.exports = __webpack_public_path__ + "media/images/agentbg-ee446da5fe96213c8f5618febf283981.png";